import { initMain } from "./vue/controllers/main";
import { header } from "./vue/controllers/header";
import { quotesMenuMixin } from "./vue/mixins/quotes";
import QuoteSearch from "./vue/components/quote-search/QuoteSearch.vue";

const mixins = [];
mixins.push(quotesMenuMixin);
initMain(
  mixins,
  {
    QuoteSearch,
    RecentQuotes: () =>
      import("./vue/components/recent-quotes/RecentQuotes.vue"),
    IpcCity: () => import("./vue/components/ipc-city/IpcCity.vue"),
    IpcSectors: () => import("./vue/components/ipc-sectors/IpcSectors.vue"),
    IpcGraph: () => import("./vue/components/ipc-graph/IpcGraph.vue"),
    Trends: () => import("./vue/components/trends/Trends.vue"),
  },
  []
);
header();
